/**
 * Oldest manufacture year accepted as a fallback for the first registration.
 * A plausibility bound against junk data, not tariff data.
 */
export const MIN_MANUFACTURE_YEAR = 1900;
